import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Crown, AlertTriangle, CheckCircle2, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/hooks/useSubscription';
import { Link } from 'react-router-dom';

export function SubscriptionSettings() {
  const { isPremium, planLabel, expiresAt, profile } = useSubscription();

  const isCancelled = profile?.subscription_status === 'cancelled';
  const isPastDue = profile?.subscription_status === 'past_due';

  const expiresLabel =
    expiresAt && format(new Date(expiresAt), "d 'de' MMMM yyyy", { locale: es });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Crown className="h-5 w-5" />
          Suscripción
        </CardTitle>
        <CardDescription>Plan actual y facturación</CardDescription>
      </CardHeader>

      <CardContent className="space-y-4">

        <div className="flex items-center justify-between">
          <div>
            <p className="font-semibold">{planLabel}</p>
            {expiresLabel && isPremium && (
              <p className="text-sm text-muted-foreground mt-0.5">
                {isCancelled ? `Acceso hasta: ${expiresLabel}` : `Renueva: ${expiresLabel}`}
              </p>
            )}
          </div>

          {isPremium && !isCancelled && !isPastDue && (
            <span className="inline-flex items-center gap-1 text-xs bg-yellow-400/10 text-yellow-500 px-2 py-1 rounded-full font-medium">
              <CheckCircle2 className="h-3 w-3" />
              Activa
            </span>
          )}
          {isPastDue && (
            <span className="inline-flex items-center gap-1 text-xs bg-destructive/10 text-destructive px-2 py-1 rounded-full font-medium">
              <AlertTriangle className="h-3 w-3" />
              Pago pendiente
            </span>
          )}
        </div>

        <Button asChild variant="outline" className="w-full justify-between">
          <Link to="/subscription">
            {isPremium ? 'Administrar suscripción' : 'Ver planes Premium'}
            <ChevronRight className="h-4 w-4" />
          </Link>
        </Button>

      </CardContent>
    </Card>
  );
}
